export default __webpack_public_path__ + "static/media/drivers.632e7d92.svg";